import { observer, use$ } from '@legendapp/state/react';
import { Button, type ButtonProps } from '@mantine/core';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PATTERN_MAP } from '../../../constants';
import { useManualBet } from '../../../hooks';
import { gameState$, manualBetState$ } from '../../../state';

export type ManualBetPickRandomBrickButtonProps = ButtonProps;

export const ManualBetPickRandomBrickButton = observer(
  (props: ManualBetPickRandomBrickButtonProps) => {
    const isBetting = use$(manualBetState$.isBetting);
    const {
      handleManualBet,
      mutation: { isPending },
    } = useManualBet();
    const { t } = useTranslation();

    const pickRandomBrick = useCallback(() => {
      const pattern = gameState$.pattern.peek();
      const { cols } = PATTERN_MAP[pattern];
      const randomRowBrickIndex = Math.floor(Math.random() * cols);
      handleManualBet(randomRowBrickIndex);
    }, [handleManualBet]);

    if (!isBetting) {
      return null;
    }

    return (
      <Button
        fullWidth
        loading={isPending}
        onClick={pickRandomBrick}
        size="lg"
        variant="outline"
        {...props}
      >
        {t('manualBet.pickRandomBrickButton.label')}
      </Button>
    );
  }
);
